import { STORAGE_KEYS } from '../../utils/constants';

export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_MODULES = 'SET_MODULES';
export const CLEAR_PERMISSIONS = 'CLEAR_PERMISSIONS';
export const INITIALIZE_PERMISSIONS = 'INITIALIZE_PERMISSIONS';

export const setPermissions = (permissions) => {
  localStorage.setItem(STORAGE_KEYS.PERMISSIONS, JSON.stringify(permissions));
  return {
    type: SET_PERMISSIONS,
    permissions,
  };
};

export const setModules = (modules) => {
  return {
    type: SET_MODULES,
    modules,
  };
};

export const clearPermissions = () => {
  localStorage.removeItem(STORAGE_KEYS.PERMISSIONS);
  return {
    type: CLEAR_PERMISSIONS,
  };
};

export const initializePermissions = () => {
  return {
    type: INITIALIZE_PERMISSIONS,
  };
};

